import Drawer from "@material-ui/core/Drawer";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import analytics from "../../../../utils/analytics";
import { removeQueryStringFromCurrentHash } from "../../../../utils/routingHelpers";


const drawerWidth = 200;

const useStyles = makeStyles(theme => ({
	root: {
		display: "flex",
		flex: "0 0 auto",
		zIndex: 1,
		"&$selected": {
			backgroundColor: theme.palette.teal.main
		},
		"&:hover": {
			color: theme.palette.dark
		},
		"&:focus": {
			color: theme.palette.dark
		},
		"& .MuiListItem-root.Mui-selected:hover": {
			backgroundColor: theme.palette.teal.dark,
			color: theme.palette.background.default,
		},
		"& .MuiListItem-root.Mui-selected:focus": {
			backgroundColor: theme.palette.teal.main,
			color: "#fff",
		}

	},
	icon: {
		color: theme.palette.primary.main,
		minWidth: theme.icons.sidebarIcons.minWidth
	},
	selected: {
		backgroundColor: theme.palette.teal.main,
		color: theme.palette.background.default,
		textDecoration: "none"
	},
	selectedIcon: {
		color: theme.palette.background.default,
		minWidth: theme.icons.sidebarIcons.minWidth
	},
	drawer: {
		width: drawerWidth,
		flexShrink: 0,
		zIndex: 1
	},
	drawerPaper: {
		zIndex: 1,
		width: drawerWidth
	},
	toolbar: theme.mixins.toolbar,
	title: {
		padding: theme.spacing(0, 4),
		textTransform: "uppercase"
	}
}));

/**
 * The Sidebar sub-navigation component used in our new React app. This component is intended to be
 * used to be used by each
 * "Page" (ex: "Folders", "Settings", etc..), where the caller composes their layout using the
 * Sidebar.
 *
 * @param {*} props
 * @returns
 */
export default function Sidebar(props) {
	const { navData, location: { hash } } = props;
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<Drawer
				className={classes.drawer}
				variant="permanent"
				classes={{
					paper: classes.drawerPaper
				}}
			>
				<div className={classes.toolbar} />

				{
					navData && navData.map((navItem, index) => {
						const sectionTitle = navItem.sectionTitle;
						return (
							<Fragment key={index}>
								<Typography
									variant="body1"
									className={classes.title}
								>
									{sectionTitle}
								</Typography>
								<MenuList>
									{
										/** 
										 * if the current hash in the URL matches the "url" prop provided on
										 * the navData item then we should make the MenuItem's class "selected"
										 * so the UI identifies the actively selected page.
										 */
										navItem.sectionItems.map((subItem) => {
											const to = subItem.url;
											const isCurrentlySelected = to === removeQueryStringFromCurrentHash(hash);

											return (
												<MenuItem
													to={to}
													key={subItem.title}
													component={Link}
													selected={isCurrentlySelected}
													classes={{
														root: classes.root,
														selected: classes.selected
													}}
													onClick={() => 
														analytics.logEvent(analytics.eventTypes.FOLDERS.SMART_VIEW_CLICKED, {
															smartView: subItem.title
														})
													}
												>
													<ListItemIcon
														className={
															isCurrentlySelected
																? classes.selectedIcon
																: classes.icon
														}
													>
														{subItem.icon}
													</ListItemIcon>
													<ListItemText primary={subItem.title} />
												</MenuItem>
											)
										})
									}
								</MenuList>
							</Fragment>
						);
					})
				}
			</Drawer>
		</div>
	);
}

Sidebar.propTypes = {
	navData: PropTypes.array,
	location: PropTypes.shape({
		hash: PropTypes.string
	}).isRequired
};
